import './style.css';
import IMG from "../../constants/image";
import React, {useState} from "react";
import ProductList from "./ProductList";
import FloatingActionButton from "../Common/Button/FloatingActionButton";
import {text} from "../../constants/text";
import {PATH} from "../../constants";
import {useNavigate} from "react-router-dom";
import {clsx} from "clsx";
import appStore from "../../store/appStore";

const ProductManagement = () => {
    const navigate = useNavigate();
    const {fromNativeApp} = appStore();
    const [isSearchMobile, openSearchMobile] = useState(false)
    const handleRedirect = () => {
        navigate(PATH.CREATE_PRODUCT)
    }

    return (
        <div className='animate-fadeIn md:pt-8'>
            <div className='relative'>
                <div className='hidden md:flex justify-center items-center gap-[5px] md:mb-2.5 md:pb-2.5'>
                    <img className='' src={IMG.icon.boxBorderGreen} alt="boxBorderGreen"/>
                    <p className='text-sm md:text-xl font-bold'>Quản lý sản phẩm</p>
                </div>
                {!isSearchMobile &&
                    <div className='hidden absolute top-0 right-3' onClick={() => openSearchMobile(true)}>
                        <img src={IMG.icon.search} alt="search"/>
                    </div>
                }
                <div
                    onClick={handleRedirect}
                    className={clsx('md:hidden fixed right-5 cursor-pointer z-[100] flex items-center justify-center space-x-1 text-sm text-white',
                        fromNativeApp ? 'top-[68px]' : 'top-[24px]'
                    )}>
                    <div className='text-2xl'>+</div>
                    <div>{text.add}</div>
                </div>
                <div className='w-full'>
                    <div className='md:bg-white rounded-xl'>
                        <ProductList isSearchMobile={isSearchMobile} openSearchMobile={openSearchMobile}/>
                    </div>
                </div>
            </div>
            <FloatingActionButton>
                <video src="/video/taosanpham.mp4" playsInline muted autoPlay loop/>
            </FloatingActionButton>
        </div>
    )
};

export default ProductManagement;